<template>
  <input type="text" name="tag_name" :id="id" class="form-control inputtags" data-role="tagsinput" />
</template>

<script>
export default {
  props: {
    id: {
      type: String
    },
    label: {
      type: String
    },
    value: {
      type: String
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    $("#" + this.id).on("itemAdded", event => {
      let value = $("#" + this.id).val();
      this.$emit("input", value);
    });

    $("#" + this.id).on("itemRemoved", event => {
      let value = $("#" + this.id).val();
      this.$emit("input", value);
    });

     $("#" + this.id).tagsinput("items");
   
  },
  watch: {
    value:{
      handler(val){
        this.$nextTick(()=>{
          this.setItems(val);
        })
              
      },
      immediate:true
    }
  },
  methods: {
    setItems(val) {

      $("#" + this.id).tagsinput("removeAll");
      if (val) {
        let vals = val.split(",");

        vals.forEach(e => {
          $("#" + this.id).tagsinput("add", e);
        });
      }
    }
  }
};
</script>